package io.horion.cv.components.dynamicfields

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.widgets.FormActionButtons
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.components.widgets.TextFormFieldWhite
import org.jetbrains.compose.web.css.px


@OptIn(DelicateApi::class)
@Composable
fun DynamicAddForm(
    label: String,
    value: String,
    index: Int,
    onValueChange: (String) -> Unit,
    onDelete: () -> Unit,
    onComplete: () -> Unit
) {

    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.SM

    Column(
        modifier = Modifier.fillMaxWidth(),
//        horizontalAlignment = Alignment.CenterHorizontally,
        horizontalAlignment = Alignment.Start
    ) {
        //  LABEL AMÉLIORÉ
        SpanText(
            text = "$label ${index + 1}",
            modifier = Modifier
                .fontSize(16.px)
                .fontWeight(com.varabyte.kobweb.compose.css.FontWeight.Medium)
                .margin(bottom = 6.px) // 👈 espace avec le champ
        )

        // 🔥 Ligne principale
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(12.px),
            verticalAlignment = Alignment.CenterVertically
        ) {

            //  Champ principal (texte dynamique)
            TextFormFieldWhite(
                value = value,
                onValueChange = { onValueChange(it) },
                placeholder = ""
            )


            //  Boutons (supprimer / valider)
            FormActionButtons(
                onDelete = onDelete,
                onComplete = onComplete,
            )
        }
    }
}